import { render, staticRenderFns } from "./ProductPatternDetail.vue?vue&type=template&id=0551159e&scoped=true&"
import script from "./ProductPatternDetail.vue?vue&type=script&lang=js&"
export * from "./ProductPatternDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductPatternDetail.vue?vue&type=style&index=0&id=0551159e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0551159e",
  null
  
)

export default component.exports